<h1 mat-dialog-title> {{ type }} Parts List </h1>
<mat-dialog-content>

  @if (type === 'Delete') {
    <p>Are you sure to delete this parts list element?</p>
  }

  @if (type === 'Update') {
    <p>Are you sure to update this parts list element?</p>
  }

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close>Cancel</button>
  @if (type === 'Delete' || type === 'Update') {
    <button mat-raised-button color="primary" (click)="onConfirmClick()">Confirm</button>
  }
</mat-dialog-actions>
